import React from 'react';
import ServiceBookingPage from '../ServiceBookingPage';

const packs = [
  {
    id: 'first_course',
    emoji: '🥉',
    name: 'First Course Pack',
    description: '2 days | Up to 10 modules',
    price: 35000000,
    duration: '2 days',
    features: ['Up to 10 edited modules', 'Slides integrated', 'Intro & outro', 'Delivery within 5 days']
  },
  {
    id: 'pro_course',
    emoji: '🥈',
    name: 'Pro Course Pack',
    description: '3 days | Up to 30 modules',
    price: 65000000,
    duration: '3 days',
    popular: true,
    features: ['Up to 30 edited modules', 'Branded intro/outro', 'Module thumbnails', '60s sales trailer', 'Delivery within 7 days']
  },
  {
    id: 'course_empire',
    emoji: '🥇',
    name: 'Course Empire Pack',
    description: '4 days | Unlimited modules + marketing',
    price: 110000000,
    duration: '4 days',
    features: ['Unlimited modules', '20 retouched photos', 'VSL (3-5 min)', '5 launch reels', '2 min sales trailer', 'Delivery within 10 days']
  }
];

const addons = [];

const customFields = [
  { id: 'course_topic', label: 'Course topic', type: 'text', placeholder: 'Digital marketing, yoga, business...' },
  { id: 'num_modules', label: 'Number of modules planned', type: 'number', placeholder: '10' },
  { id: 'script_ready', label: 'Do you have a script ready?', type: 'select', options: [
    { value: 'yes', label: 'Yes, fully prepared' },
    { value: 'in_progress', label: 'In progress' },
    { value: 'no', label: 'No, I need help with that' }
  ]},
  { id: 'platform', label: 'Which platform will host your course?', type: 'text', placeholder: 'Teachable, Kajabi, own website...' }
];

export default function OnlineCourseBookingPage() {
  return (
    <ServiceBookingPage
      serviceType="online_course"
      serviceTitle="Online Course Filming"
      serviceSubtitle="Full course production"
      packs={packs}
      addons={addons}
      customFields={customFields}
      backLink="/services/online-course-filming"
    />
  );
}
